import { render } from "./VerificationStatusApproved.vue?vue&type=template&id=1ba0e945&scoped=true&ts=true"
import script from "./VerificationStatusApproved.vue?vue&type=script&lang=ts"
export * from "./VerificationStatusApproved.vue?vue&type=script&lang=ts"

import "./VerificationStatusApproved.vue?vue&type=style&index=0&id=1ba0e945&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba0e945"],['__file',"src/components/transaction/VerificationStatusApproved.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ba0e945"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ba0e945', __exports__)) {
    api.reload('1ba0e945', __exports__)
  }
  
  module.hot.accept("./VerificationStatusApproved.vue?vue&type=template&id=1ba0e945&scoped=true&ts=true", () => {
    api.rerender('1ba0e945', render)
  })

}


export default __exports__